module.exports = __webpack_public_path__ + "img/discount.f9d08687.png";